import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';

import UsersList from './UsersList';
import UserDetail from './UserDetail';

const Users = () => (
  <Routes>
    <Route index element={<UsersList />} />
    <Route path=":userId" element={<UserDetail />} />
    <Route path="*" element={<Navigate to="." replace />} />
  </Routes>
);

export default Users;
